import i18n from '@/i18n/index'
import quillText from '@/components/quillText'

export default {
  formData: [{
    title: i18n.t('table.product.basicInformation'),
    name: 0,
    createDateItem: [{
      span: 8,
      prop: 'name',
      name: 'input',
      label: 'Name',
      placeholder: i18n.t('placeholder.defaultInput'),
      Object: {
      }
    }, {
      span: 8,
      prop: 'hotel_id',
      name: 'select',
      options: [],
      value: [],
      label: 'Hotel',
      placeholder: i18n.t('placeholder.defaultSelect'),
      Object: {
        filterable: true
      }
    }, {
      span: 8,
      prop: 'bed_type',
      name: 'select',
      options: [],
      value: [],
      label: 'Bed Type',
      placeholder: i18n.t('placeholder.defaultSelect'),
      Object: {
        filterable: true
      }
    }, {
      span: 8,
      prop: 'capacity',
      name: 'input',
      type: 'number',
      label: 'Capacity',
      placeholder: 'Capacity',
      Object: {
        filterable: true
      }
    }, {
      span: 8,
      prop: 'room_size',
      name: 'input',
      type: 'number',
      label: 'Room Size',
      placeholder: 'Room Size',
      Object: {
        filterable: true
      }
    }, {
      span: 24,
      prop: 'short_description',
      name: 'input',
      type: 'textarea',
      label: 'Short Description',
      placeholder: 'Short Description',
      Object: {
        rows: 4
      }
    }, {
      span: 24,
      prop: 'feature_details',
      name: 'component',
      label: 'Feature Details',
      placeholder: 'Feature Details',
      Object: {
        name: quillText
      }
    }, {
      span: 24,
      prop: 'images_attributes',
      name: 'image',
      value: [],
      label: i18n.t('form.common.image'),
      placeholder: i18n.t('placeholder.defaultInput'),
      Object: {
        limit: 100,
        imageName: 'remote_image_url'
      }
    }]
  }]
}
